import { Pipe,PipeTransform } from '@angular/core';
import * as _ from 'underscore';

@Pipe({
    name: 'empStatus'
})
export class EmployeeStatus implements PipeTransform {
    public assignValue: any;
    public empStatusDetails: any = [{
            status: 1,
            value: "ACTIVE"
        },
        {
            status: 2,
            value: "SUSPEND"
        },
        {
            status: 3,
            value: "RESIGN"
        },
        {
            status: 4,
            value: "INACTIVE"
        }
    ]

    transform(value: any): any {
        let self = this;
        _.each(this.empStatusDetails,function(element){
            if(value == element.status){
                self.assignValue = element.value; 
            }
        })
        return self.assignValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/employee/statusPipe.ts